import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const BookYourEventStyle = styled('div')`
    padding-top: 24px;
    margin-top: 48px;
    border-top: 1px solid var(--sand-400);

    .title-card {
        color: var(--sand-700);
        ${typography.subhead}
        margin-bottom: 12px;
    }

    .why-book {
        ${typography.bodyXs}
        color: var(--sand-600);
        .item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 6px 0;

            .icon-check {
                color: var(--orange-300);
                margin-top: 3px;
            }
        }
    }
`;
export default BookYourEventStyle;
